import React from 'react';
import Container from '@material-ui/core/Container';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import styles from './CustomContainer.module.scss';


//container that abides by requiremets in design
export default function CustomContainer(props) {
  const { children, classes, special, subpage, ...rest } = props;

  const theme = useTheme();
  const bpLgDown = useMediaQuery(theme.breakpoints.down('lg'));
  const bpSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const bpXsDown = useMediaQuery(theme.breakpoints.down('xs'));
  
  const rootClassNames = special ? clsx(
      styles.padding_bp_xl,
      bpLgDown && styles.padding_bp_lg_special,
      bpXsDown && styles.padding_bp_xs_special,
      classes && classes.root, 
    ) : (subpage ? (
      clsx(
        styles.padding_bp_xl,
        classes && classes.root,
      )) : 
    clsx(
      styles.padding_bp_xl,   
      bpLgDown && styles.padding_bp_lg, 
      bpSmDown && styles.padding_bp_sm, 
      bpXsDown && styles.padding_bp_xs, 
      classes && classes.root,
    ));

  return (
    <Container 
      classes={{ ...classes, root: rootClassNames }}
      { ...rest }
    >
      {children}
    </Container>
  );
}